import { atom } from "jotai";

export const trackKnownBandwidthAtom = atom(true);
